<template>
  <CFormGroup
          v-bind="{append, prepend, validFeedback, invalidFeedback,
        tooltipFeedback, description, wrapperClasses, class: computedClasses}"
      :style="wrapperAttrs.style"
      :class="wrapperAttrs.class"
  >
    <template #label>
      <slot name="label">
        <label v-if="label" :for="safeId" :class="labelClasses">
          {{ label }}
        </label>
      </slot>
    </template>
    <template #input>
      <treeselect
          v-model="state"
          :async="true"
          :load-options="load_links"
          placeholder="جستجو لینک"
          :normalizer="normalizer_links"
      />
    </template>

    <template
            v-for="slot in passSlots"
            #[slot]
    >
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
  import CFormGroup from '@/coreui/form/CFormGroup.vue'
  import {inputProps as props} from '@/coreui/form/form-props'
  import * as allFormMixins from '@/coreui/form/form-mixins'

  import Treeselect from '@zanmato/vue3-treeselect'
  import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css'

  import {ASYNC_SEARCH} from '@zanmato/vue3-treeselect'
  import axios from "@/api/http";
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  props.whitout_decimal=Boolean;

  const { initialValue, ...mixinMap } = allFormMixins
  const mixins = Object.values(mixinMap)

  export default {
    name: 'CInput',
    slots: [
      'prepend',
      'prepend-content',
      'append-content',
      'append',
      'label-after-input',
      'valid-feedback',
      'invalid-feedback',
      'description'
    ],
    inheritAttrs: false,
    emits: ['input', 'change', 'update:value', 'update:modelValue'],
    components: {CFormGroup,
      Treeselect},
    mixins,
    props,
    data() {
      return {

        state: initialValue(this),
        syncTimeout: null,
        load_links({action, searchQuery, callback}) {

          if (action === ASYNC_SEARCH) {
            simulateAsyncOperation(() => {
              let options;
              axios.post('/api/admin/site/search_links', {
                search: searchQuery,

              },{show_pros:false}).then(function (response) {
                options = response.data;
                callback(null, options);
                // localStorage.setItem("api_token", response.data.access_token);
                // self.$router.push({ path: 'notes' });
              })
                  .catch(function (error) {
                    console.log(error);
                  });


            })
          }
        },
        normalizer_links(node) {
          return {
            id: "/"+node.prefix+"/"+node.slug,
            label:node.name+" "+ node.title,
          }
        },
      }
    },
    mounted() {

    },
    computed: {
      passSlots () {
        return this.$options.slots.filter((s) => this.$slots[s])
      },

    },
    watch:{
      'state':function (){

        this.$emit('input', this.state)
        this.$emit('update:modelValue', this.state)
      }
    },
    methods: {
      onInput(e) {

        this.state = e.target.value
        this.$emit('input', this.state, e)
        this.$emit('update:modelValue', this.state)
        if (this.lazy === true) {
          return
        }
        this.syncTimeout = setTimeout(() => {
          this.$emit('update:value', this.state, e)
        }, this.lazy !== false ? this.lazy : 0)
      },
      onChange(e)
      {
        this.$emit('change', this.state, e)
        this.$emit('update:value', this.state, e)
      },

    },


  }
</script>
